var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{class:{[_vm.classIcon]: true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }